// extracted by mini-css-extract-plugin
export default {"anchor":"DUtTKdDGM9tjjy99BaLe","preview":"lQ0XOx86EZnlOTS8CPZ6","play":"RJmbpWe5pslTJLV812So","overlay":"leMhHkmkTJxp9wc0fVzz","thumb":"DXRzLQCh1Alw1PfXFRqQ"};